import { myImageLoader } from '@/lib/imageLoader';
import * as S from './style';
import { MainImage } from '../AuthorPage.styles';
import { TPublicBlogs } from '@/entities/Blogs/domain/Blogs.domain';
import URL from '@/common/app/utils/urlsUtils';
import { Container } from '@/common/ui/containers/Container';
import { useCarousel } from '@/common/app/hooks/useCarousel';
import { useRef } from 'react';
import Link from 'next/link';
import { SliderDots } from '@/common/ui/dots/SliderDots/SliderDots';

export const TopAuthorsBlogs = ({
    authorImage,
    title,
    blogs,
}: {
    authorImage: string;
    title: string;
    blogs: TPublicBlogs;
}) => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const {
        prevBtnIsActive,
        nextBtnIsActive,
        onClickHandler,
        onScrollHandler,
        DIRECTION,
        dotActive,
        containerWidth,
    } = useCarousel({ ref: scrollRef, countItems: blogs.items.length });
    const withDot = blogs.items.length > 1;

    return (
        <>
            <S.Wrapper>
                <Container>
                    <S.Block className="container">
                        <S.Header>
                            <S.Title>{title.split(' ')[0]}&apos;s Top Articles</S.Title>
                        </S.Header>
                        <S.CarouselWraper>
                            <S.Gallery ref={scrollRef} onScroll={onScrollHandler}>
                                <S.InnerContainer className="carousel-container">
                                    {blogs.items.map((i) => (
                                        <S.Card
                                            key={i.slug}
                                            style={{
                                                width: containerWidth,
                                                ...(!containerWidth && { opacity: 0 }),
                                            }}
                                            className="card"
                                        >
                                            <S.Content>
                                                <S.Author>
                                                    <S.AuthorImage>
                                                        {Boolean(authorImage) && (
                                                            <MainImage
                                                                loader={myImageLoader}
                                                                src={authorImage}
                                                                width={400}
                                                                height={400}
                                                                alt="Profile photo"
                                                            />
                                                        )}
                                                    </S.AuthorImage>
                                                    <S.AuthorText>
                                                        <span>by {title}</span>
                                                        <S.AuthorMeta>
                                                            <span>{i.updated_at}</span>
                                                        </S.AuthorMeta>
                                                    </S.AuthorText>
                                                </S.Author>

                                                <S.Title>{i.title}</S.Title>

                                                <S.Description>{i.description}</S.Description>
                                                <S.FeaturedImageMobile
                                                    src={`${URL.image}/blog/${i.image.id}/${i.image.slug}`}
                                                    alt={i.title}
                                                />
                                                <Link href={`/blog/${i.slug}/`} passHref>
                                                    <S.ReadButton>Read the article</S.ReadButton>
                                                </Link>
                                            </S.Content>
                                            <S.FeaturedImage
                                                src={`${URL.image}/blog/${i.image.id}/${i.image.slug}`}
                                                alt={i.title}
                                            />
                                        </S.Card>
                                    ))}
                                </S.InnerContainer>
                            </S.Gallery>
                            {prevBtnIsActive && withDot && (
                                <S.CenterLeftArrow
                                    onClick={() => onClickHandler(DIRECTION.prev)}
                                    disabled={false}
                                />
                            )}
                            {nextBtnIsActive && withDot && (
                                <S.CenterRightArrow
                                    onClick={() => onClickHandler(DIRECTION.next)}
                                    disabled={false}
                                />
                            )}
                        </S.CarouselWraper>
                        {withDot && (
                            <S.DotsSlider>
                                {[...Array(blogs.items.length).keys()].map((el) => {
                                    return (
                                        <SliderDots
                                            isActive={el === Math.ceil(dotActive)}
                                            key={el}
                                            size={8}
                                            desktop
                                        />
                                    );
                                })}
                            </S.DotsSlider>
                        )}
                    </S.Block>
                </Container>
            </S.Wrapper>
        </>
    );
};
